/**
 * @file Re-exports the update-identity-email link component.
 */
import UpdateIdentityEmailLink from "./UpdateIdentityEmailLink";

export default UpdateIdentityEmailLink;
